
































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";
import axios from "axios";
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
});

import rtDatePicker from "@/components/couponcancel/rtDatePicker.vue";
const reportSalesModule = namespace("reportSales");

@Component({
  components: {
    rtDatePicker
  }
})
export default class Form extends Vue {
  @reportSalesModule.State("paymentTypeList") formList!: any;

  tradeTime: string = "";
  fileList: any = [];
  urls: any = [];
  totleAmount: number = 0;
  totleCount: number = 0;

  mounted() {
    this.getData();
  }

  get action() {
    return this.$http["FILE_UPLOAD"].api;
  }

  handleSumChange() {
    if (this.formList.length === 0) {
      this.totleAmount = 0;
      this.totleCount = 0;
    } else {
      this.totleAmount = 0;
      this.totleCount = 0;
      this.formList.forEach((item: any, index: number) => {
        this.totleAmount =
          this.totleAmount + Number(item.paymentTotalAmount) || 0;
        this.totleCount = this.totleCount + Number(item.paymentCount) || 0;
      });
    }
  }

  del(url: any) {
    let index = this.fileList.indexOf(url);
    this.fileList.splice(index, 1);
  }

  handleCreateClick() {
    this.fileList &&
      this.fileList.map((val: any) => {
        this.urls.push(val.url);
      });
    let payStatus: boolean = false;
    if (this.tradeTime.trim() === "") {
      this.$toast("请选择日期");
      return false;
    }
    let arr = this.formList.filter((item: any) => {
      return item.paymentTotalAmount !== "" && item.paymentCount !== "";
    });
    if (arr && arr.length == 0) {
      this.$toast(`请填写一项销售金额和销售笔数`);
      return false;
    }
    console.log(arr);
    console.log(this.formList);
    // this.formList.forEach((item: any) => {
    // arrName.push(item.paymentTotalAmount)
    // arrNum.push(item.paymentCount)
    // if (item.paymentTotalAmount === '') {
    //   payStatus = true
    //   this.$toast(`请添加 ${item.paymentName} 销售金额`)
    //   return false
    // } else if (item.paymentCount === '') {
    //   payStatus = true
    //   this.$toast(`请添加 ${item.paymentName} 销售笔数`)
    //   return false
    // }
    // })
    // if (payStatus) {
    //   return false
    // }
    if (this.urls.length === 0) {
      this.$toast("请上传小票");
      return false;
    }
    console.log({
      parentTenantId: this.$global.parentBusinessEntityId,
      parentTenantType: this.$global.parentBusinessEntityTypeId,
      paymentWays: arr,
      tradeTime: this.tradeTime,
      urls: this.urls
    });
    this.addSaleRecord(arr);
  }

  async getData() {
    const { success } = await this.$store.dispatch(
      "reportSales/getPaymentTypeList",
      {
        parentTenantId: this.$global.parentBusinessEntityId,
        parentTenantType: this.$global.parentBusinessEntityTypeId
      }
    );
  }
  renderFormData(data: any) {}

  async addSaleRecord(arr: any) {
    const { error, success }: any = await this.$request("SALE_RECORD_ADD", {
      parentTenantId: this.$global.parentBusinessEntityId,
      parentTenantType: this.$global.parentBusinessEntityTypeId,
      paymentWays: arr,
      tradeTime: this.tradeTime,
      urls: this.urls
    });
    if (success) {
      this.$router.push("/reportSales");
    }
    if (error) {
      Toast(error.msg);
    }
  }

  uploadfiles(val: any, index: any) {
    //图文图片上传
    // console.log(index);
    const param = new FormData();
    param.append("file", val.file);
    instance
      .post(this.action, param, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        if (res.data.status == 200) {
          if (res.data.data.path) {
            this.fileList.push({ url: res.data.data.path });
          }
        } else {
          Toast(res.data.message);
        }
      });
  }
}
